<template>
  <router-link
    :to="{
      name: 'signoffs.overview',
      params: { signoff_id: signOff.id },
    }"
  >
    <div class="row">
      <div class="col-12 col-lg-7 col-xl-7">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Name:</span>
          <span class="strong">{{ signOff.contact.client.company }}</span
          ><br />
          <span class="d-inline-block mt-1">{{ signOff.project_stage.project.title }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-1 col-xl-1">
        <div class="user-avatar">
          <div class="avatar avatar-sm">
            <img
              alt="member"
              class="img-circle"
              v-bind:src="getAvatar(signOff.user_id)"
            />
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-2 col-xl-2">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Stage:</span>
          {{ signOff.project_stage.stage.name }}
        </p>
      </div>
      <div class="col-6 col-lg-2 col-xl-2 text-end">
        <p>
          <span class="data-label d-lg-none">Status:</span>
          <span
            v-bind:class="getStatusColor(signOff.status)"
            class="status"
            >{{ signOff.status }}</span
          >
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    signOff: {
      required: true,
      type: Object,
    },
  },

  computed: {},

  methods: {
    getStatusColor(status) {
      switch (status) {
        case "Draft":
          return "status-mute";
          break;
        case "Sent":
          return "status-info";
          break;
        case "Pending Approval":
          return "status-warning";
          break;
        case "Approved":
          return "status-info";
          break;
        case "Viewed":
          return "status-primary";
          break;
        case "Declined":
          return "status-warning";
          break;
        case "Signed":
          return "status-success";
          break;
        case "Expired":
          return "status-danger";
          break;
      }
    },

    dueIn(dueDate) {
      var today = moment();
      var d = moment(dueDate);
      return d.diff(today, "days");
    },

    getAvatar(id) {
      return process.env.VUE_APP_API_URL + "/user/" + id + "/avatar";
    },
  },
};
</script>
